import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { PASSWORD_PATH } from '../../constants/route.constants';
import UserSlice from '../../common/slices/UserSlice';

type BaseRouteProps = {
    children?: ReactNode;
};

export default function BaseRoute(props: BaseRouteProps): JSX.Element {
    const { children } = props;
    const { data } = useSelector(UserSlice.state.info);

    if (data?.forceChangePassword === true) {
        return <Navigate to={PASSWORD_PATH} replace relative="path" />;
    }

    return <>{children}</>;
}
